import { render, staticRenderFns } from "./CarCreate.vue?vue&type=template&id=4543387c&scoped=true&"
import script from "./CarCreate.vue?vue&type=script&lang=js&"
export * from "./CarCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543387c",
  null
  
)

export default component.exports